import { RoundedIconButton } from '@/components/buttons/Buttons';
import { Panel } from 'primereact/panel';
import { MdOutlineDelete, MdOutlineModeEdit } from 'react-icons/md';
import './add-item.styles.css';
import { X4bEmployeeListItem } from '@/types';

type Props = {
	item: X4bEmployeeListItem,
	onEdit?: () => void
	onDelete?: () => void
};

const AddItem = (props: Props) => {

	return (
		<Panel header="" className="add-item-container">
			<div className="item-content">
				<p className="item-name">{props.item.FirstName} {props.item.LastName}</p>
				<div>
					<p>{props.item.Email}</p>
					<p>{props.item.Phone}</p>
				</div>
				<div>
					<p>ID: {props.item.ReferenceCode}</p>
					<p>{props.item.RoleName}</p>
				</div>
			</div>
			<div className="item-actions">
				<RoundedIconButton
					id="item-edit"
					icon={MdOutlineModeEdit}
					iconSize="24"
					className="secondary"
					onClick={() => props.onEdit?.()}
				/>

				<RoundedIconButton
					id="item-delete"
					icon={MdOutlineDelete}
					iconSize="24"
					className="secondary"
					onClick={() => props.onDelete?.()}
				/>
			</div>
		</Panel>
	);
};

export default AddItem;
